module.exports = __webpack_public_path__ + "img/joinUs_1.27cfc09d.png";